import moment from 'moment';
import { setProfileLastTouchFavorited } from 'utils/Socialization';
import Axios from 'axios';
import api from '../../../../services/api/microfwk';
import { getBookmarks } from '../utils';
import { deleteFavorited } from '../../../Vcard/services/favorite.service';
import { getUserSeenDel } from '../../../../services/api/user/seen';
import { useGetRecordings } from '../../components/ContentsCarouselContainer/hooks/useGetRecordings';
import {
  transformCmsInfo,
  transformCmsUserInfo,
} from '../../utils/carouselsUtils';
import {
  DELETE_CONTINUE_VIEWING_ITEM,
  GET_CMS_LEVEL_NODE_INFO,
  REMOVE_MY_LIST_ITEM,
  SET_CMS_CONTENT_LIST,
  DELETE_POSTER_RECORDING,
} from '../constants';
import {
  getNavType,
  getNavTypeHomologacion,
} from '../../../../utils/getNavType';
import { GetEpgVersion } from 'utils/getEpgParams';
import { HttpClient } from 'api/helpers/HttpClient';
import { getRegion } from 'utils/Region';
import { apiCall } from 'api';
import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';
import { deleteFavContentService } from 'api/services/user/favorites';
import _ from 'lodash';
import { GetRegion } from 'constants';
import {
  CMS_LEVEL_PATH_SERVICES,
  CMS_LEVEL_USER_PATH_SERVICES,
} from 'api/services/content/paths';
import { module_version } from 'api/services/content/module_version';
import { getUserToken } from 'utils/user/getUserToken';
import { getFavoriteChannels } from 'containers/EPG/actions/favorite/favorite.actions';
import { jsonParseCatch } from 'utils/getTranslation';

// EJECUTA LOS SERVICIOS DE CMS
export const getCmsInfo = ({
  node,
  userHash,
  setIsLoading,
  setIsInfiniteList,
  isInfiniteList,
  layout,
}) => async (dispatch, getState) => {
  const user_token = getUserToken();

  try {
    setIsLoading(true);
    // Llamada a cms/level
    const params = { node, type: getNavTypeHomologacion() };
    const { data: cmsLevelResponse } = await apiCall.get(
      CMS_LEVEL_PATH_SERVICES,
      {
        params: {
          ...params,
          user_hash: null,
        },
        metadata: {
          user_token,
        },
      },
    );

    // Minifica los datos de la respuesta de cmsLevel
    const cmsLevelModules = transformCmsInfo(
      cmsLevelResponse?.response?.modules?.module,
    );

    // Llamada a cms/leveluser
    setIsInfiniteList(
      cmsLevelResponse?.response?.modules?.module?.[0]?.type ===
        'listadoinfinito',
    );
    // Si el usuario esta loggeado hace la llamada
    if ((!isInfiniteList || layout === 'playandgo') && userHash) {
      const paramsUserLevel = {
        node,
        user_hash: userHash,
        type: getNavTypeHomologacion(),
      };
      const { data: cmsLevelUserResponse } = await apiCall.get(
        CMS_LEVEL_USER_PATH_SERVICES,
        {
          params: {
            ...paramsUserLevel,
            user_hash: null,
          },
          metadata: {
            user_token,
          },
        },
      );

      // Minifica los datos de la respuesta de cmsLevelUser
      const cmsLevelUserModules = transformCmsUserInfo(
        cmsLevelUserResponse?.response?.modules?.module,
      );

      // Unifica la cmsLevel y la cmsLevelUser
      cmsLevelModules?.map(module => {
        if (module?.component?.properties?.byuser === 'true') {
          const findedUserModule = cmsLevelUserModules?.find(
            userModule => userModule?.name === module?.name,
          );

          // Asigna el tipo de carrusel
          module.component.type =
            findedUserModule?.component?.properties?.type ||
            findedUserModule?.component?.type;
          // Asigna el sub tipo de carrusel
          module.component.sub_type = findedUserModule?.component?.type;
          // Asigna el parametro user
          module.component.properties = {
            ...findedUserModule?.component?.properties,
            byuser: 'true',
          };
        }
        return module;
      });
    }

    // Hace el dispatch para guardar los carruseles
    dispatch({
      type: GET_CMS_LEVEL_NODE_INFO,
      payload: {
        node: [node],
        cmsLevelModules,
        loaded: true,
        userHash,
      },
    });

    setIsLoading(false);
  } catch (error) {
    console.log(error);
  }
};

// Obtiene el listado de contenidos
export const getContentList = ({
  url,
  index,
  node,
  carouselType,
  userhash,
}) => async (dispatch, getState) => {
  try {
    const { token, superHighlight, userType } = getState()?.user || {};
    const byrFilterlist = getState()?.metadata?.byr_filterlist_configuration
    let user_status = superHighlight?.join();
    const user_token = getUserToken();

    if (userType === 'ANONYMOUS') {
      user_status = 'anonymous';
    }

    const cv_advertising_config = getClaroAdsKey(getState());

    let params = {
      event_date: moment().format('YYYYMMDDHHMMSS'),
    };
    if (!cv_advertising_config || url.includes('services/content/list')) {
      params.api_version = 'v5.93';
    }

    if (url?.search('superhighlight') >= 0) {
      params = {
        ...params,
        user_status,
        api_version: null,
      };
    }

    if(carouselType === "favorited"){
      const favoriteParams = new URLSearchParams(url?.split("?")[1]);

      if(!favoriteParams.has("filterlist")){
        params = {
          ...params,
          filterlist: jsonParseCatch(byrFilterlist)?.[getRegion()]?.filterlist
        }
       }
    }

    if (url?.search('recordings') >= 0) {
      params = {
        user_token,
        event_date: moment().format('YYYYMMDDHHMMSS'),
        api_version: 'v5.94',
      };
    }


    if (carouselType === 'FavoritedLive') {
      params = {
        user_token,
        event_date: moment().format('YYYYMMDDHHMMSS'),
        epg_version: GetEpgVersion(),
        live: true,
      };
    }

    if (carouselType === 'planselector') {
      delete params?.user_token;
      delete params?.event_date;
    }

    if (url?.search('favorited') >= 0) {
      const filterlist = _.get(
        window.utils.getMeta.metadata('byr_filterlist_configuration'),
        [GetRegion(), 'filterlist'],
      );

      params.filterlist = filterlist;
    }

    if (url?.search('content') >= 0) {
      params = {
        user_token: null,
        HKS: null,
        node,
        module_version,
      };
    }

    const { data: contentListResponse } = await apiCall.get(url, { params });
    // Si hay un error
    if (contentListResponse.msg === 'ERROR' || contentListResponse?.x === null) {
      // Se realiza esta accion cuando hay un error por tema de lazyload en los carruseles
      dispatch({
        type: SET_CMS_CONTENT_LIST,
        payload: {
          contentList: [],
          index,
          node,
          hasError: true,
        },
      });
    }

    // Injecta los bookmarks en la respuesta
    let contentList;
    if (userhash && carouselType === 'seen') {
      contentList = await getBookmarks({
        contenidos: contentListResponse?.response,
        user_hash: userhash,
      });
    } else if (userhash && carouselType === 'recording') {
      const data = useGetRecordings(contentListResponse);
      contentList = data;
    } else if (contentListResponse?.offers) {
      // plan selector publicidad
      contentList = { groups: contentListResponse?.offers };
    } else {
      contentList = contentListResponse?.response;
    }

    // Si tiene exito la peticion
    dispatch({
      type: SET_CMS_CONTENT_LIST,
      payload: {
        contentList,
        index,
        node,
      },
    });
  } catch (error) {
    dispatch({
      type: SET_CMS_CONTENT_LIST,
      payload: {
        contentList: [],
        index,
        node,
        hasError: true,
      },
    });
  }
};

// ESTA ACCION SIRVE PARA ELIMINAR UN CONTENIDO DEL CARRUSEL DE SEGUIR VIENDO
export const seenDeleteItem = ({ contentId, node, index }) => async (
  dispatch,
  getState,
) => {
  try {
    const { userhash } = getState().user;
    const deletedItem = await getUserSeenDel({
      object_id: contentId,
      user_hash: userhash,
      object_type: 1,
    });

    dispatch({
      type: DELETE_CONTINUE_VIEWING_ITEM,
      payload: {
        contentId,
        node,
        index,
      },
    });

    if (deletedItem?.lasttouch && deletedItem?.lasttouch?.seen) {
      localStorage.setItem('lasttouchSeen', deletedItem?.lasttouch?.seen);
    }
  } catch (error) {
    console.log(error);
  }
};

// ESTA ACCION SIRVE PARA ELIMINAR UN CONTENIDO DEL CARRUSEL DE MI LISTA
export const removeMyListItem = ({ contentId, node, index }) => async (
  dispatch,
  getState,
) => {
  try {
    const claroLiteConfig = getClaroAdsKey(getState());
    const { userhash } = getState()?.user || {};
    const params = {
      object_id: contentId,
      user_hash: userhash,
      object_type: 1,
      claroLiteConfig,
    };

    const deleteResponse = await deleteFavContentService(params).then(
      ({ data }) => data,
    );
    if (deleteResponse.status === '0') {
      dispatch({
        type: REMOVE_MY_LIST_ITEM,
        payload: {
          contentId,
          node,
          index,
        },
      });
    }
    if (deleteResponse?.lasttouch && deleteResponse?.lasttouch?.favorited) {
      setProfileLastTouchFavorited(deleteResponse?.lasttouch?.favorited);
    }
  } catch (error) {
    console.log(error);
  }
};

export const deletePosterRecording = options => async dispatch => {
  // constantes
  const { data: dataCurrenPoster, node, index, deleteAnalytics } =
    options || {};
  const { deleteURl } = dataCurrenPoster || {};

  try {
    // eliminando el poster
    const resDeletePoster = await Axios.post(deleteURl);

    // se llama al dispatch para actualizar el state
    if (resDeletePoster?.status === 200) {
      dispatch({
        type: DELETE_POSTER_RECORDING,
        payload: {
          node,
          index,
          dataCurrenPoster,
        },
      });

      if (typeof deleteAnalytics === 'function') {
        deleteAnalytics();
      }
    }
  } catch (error) {
    console.error(error);
  }
};
